import MarkdownParser from 'components/rich-text/markdown-parser';
import styles from './no-results.module.scss';
const NoResults = ({ title, body }: IProps) => {
	return (
		<div className={styles.container}>
			<div className={styles.title}>{title}</div>
			{body && (
				<div>
					<MarkdownParser>{body}</MarkdownParser>
				</div>
			)}
		</div>
	);
};

export default NoResults;

interface IProps {
	title: string;
	body?: string;
}
